var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60ZM26 42C26.6633 42 26.9664 41.7029 27.3328 41.3438L27.3636 41.3136L30.4226 38.319L37.6329 43.6458C38.9439 44.3692 39.89 43.9947 40.2166 42.4287L44.893 20.3927C45.3718 18.4732 44.1613 17.6026 42.9071 18.172L15.4474 28.7599C13.573 29.5117 13.584 30.5574 15.1058 31.0233L22.1525 33.2227L38.4666 22.9307C39.2367 22.4637 39.9436 22.7148 39.3634 23.2297L26.1444 35.1583L26.4392 35.3761L26 42Z",
    fill: "#EF533F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.50800a767e8002aecb8d58505285241b.svg";
export { ForwardRef as ReactComponent };